var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"subheader",staticClass:"sticky",on:{"click":_vm.scrollToTop}},[(_vm.crumbs.length > 0)?_c('v-breadcrumbs',{attrs:{"items":_vm.crumbs,"large":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }